// extracted by mini-css-extract-plugin
export var container = "_m2-0";
export var dotAnimation = "_m2-2";
export var dotsLoading = "_m2-1";